import styled from 'styled-components';

export type StyledActionsProps = {
  toTheRight?: boolean;
};

const Container = styled.div<StyledActionsProps>`
  display: flex;

  gap: 1.2rem;

  justify-content: ${({ toTheRight }) => (toTheRight ? 'flex-end' : 'flex-start')};
`;

export { Container };
